export const padStart = (number: number) => number.toString().padStart(2, '0');

export const getDurationParts = (totalHours: number, plus = '', minus = '-') => {
    const sign = totalHours < 0 ? minus : plus;
    const absHours = Math.abs(totalHours).toString();
    const hours = parseInt(absHours, 10);
    const minutes = Math.floor((Number(absHours) - hours) * 60);
    return { sign, hours, minutes };
};

export const readableDuration = (totalHours: number, forcePlusSign = false) => {
    if (!totalHours) {
        return '-';
    }
    const plus = forcePlusSign ? '+' : '';
    const { sign, hours, minutes } = getDurationParts(totalHours, plus);

    return `${sign}${padStart(hours)}:${padStart(minutes)} hs`;
};
